angular.module('leanlaw').directive('llClientMatterSearch', ['clientMatterOptionsService', 'leanLawAuth', function (clientMatterOptionsService, leanLawAuth) {
  return {
    restrict: 'EA',
    scope: {
      cm: '=?ngModel',
      matter: '=?',
      horizontal: '=',
      line: '@',
      hideAllButton: '@',
      showAddMatter: '@',
      noDeselect: '@',
      useBlockClass: '@',
      status: '=',
      clientOnly: '=',
      queryFilter: '=',
      me: '=',
      hideClientLabel: '=',
      hideLabels: '=',
      lockEditing: '='
    },
    template: require('./views/clientMatterSearch.html'),
    controller: ['clientMatterOptionsService', '$scope', '$state', function (clientMatterOptionsService, $scope, $state) {
      $scope.itemSearchThreshold = 200;
      $scope.clients = [];
      $scope.filteredClients = [];
      $scope.matters = [];
      $scope.filteredMatters = [];
      $scope.mattersLoading = false;
      $scope.clientsLoading = false;
      $scope.searchingClients = false;
      $scope.searchingMatters = false;
      $scope.clientCount = 0;
      $scope.matterCount = 0;
      if (!$scope.cm) {
        $scope.cm = {
          client: null,
          matter: null
        };
      }
      $scope.lastClientQuery = {
        originating: $scope.queryFilter.originating || false,
        involved: $scope.queryFilter.involved || false,
        reviewer: $scope.queryFilter.reviewer || false,
        primary: $scope.queryFilter.primary || false,
        scopeAccount: $scope.queryFilter.scopeAccount || null,
        archived: $scope.queryFilter.archived || false,
        search: '',
        showOrphans: $scope.queryFilter.showOrphans || false,
        showSecondarySplitMatter: $scope.queryFilter.showSecondarySplitMatter || false
      };
      $scope.clientQuery = {
        originating: $scope.queryFilter.originating || false,
        involved: $scope.queryFilter.involved || false,
        reviewer: $scope.queryFilter.reviewer || false,
        primary: $scope.queryFilter.primary || false,
        scopeAccount: $scope.queryFilter.scopeAccount || null,
        archived: $scope.queryFilter.archived || false,
        search: '',
        showOrphans: $scope.queryFilter.showOrphans || false,
        showSecondarySplitMatter: $scope.queryFilter.showSecondarySplitMatter || false
      };
      $scope.lastMatterQuery = {
        originating: $scope.queryFilter.originating || false,
        involved: $scope.queryFilter.involved || false,
        reviewer: $scope.queryFilter.reviewer || false,
        primary: $scope.queryFilter.primary || false,
        scopeAccount: $scope.queryFilter.scopeAccount || null,
        archived: $scope.queryFilter.archived || false,
        search: '',
        clientId: $scope.cm.client ? $scope.cm.client.id : null,
        showSecondarySplitMatter: $scope.queryFilter.showSecondarySplitMatter || false
      };
      $scope.matterQuery = {
        originating: $scope.queryFilter.originating || false,
        involved: $scope.queryFilter.involved || false,
        reviewer: $scope.queryFilter.reviewer || false,
        primary: $scope.queryFilter.primary || false,
        scopeAccount: $scope.queryFilter.scopeAccount || null,
        archived: $scope.queryFilter.archived || false,
        search: '',
        clientId: $scope.cm.client ? $scope.cm.client.id : null,
        showSecondarySplitMatter: $scope.queryFilter.showSecondarySplitMatter || false
      };

      //old code
      $scope.allowEmpty = !$scope.noDeselect;
      $scope.domain = `${leanLawAuth.domain}/v1`;
      $scope.loadMatterOptions = loadMatterOptions;
      $scope.fetchMatters = fetchMatters;
      $scope.highlightedClientIndex = -1;
      $scope.highlightedMatterIndex = -1;
      if (!$scope.cm) {
        $scope.cm = {
          client: null,
          matter: null
        };
      }
      $scope.useClientSearch = function () {
        return $scope.clientCount > $scope.itemSearchThreshold;
      };
      $scope.useMatterSearch = function () {
        return $scope.matterCount > $scope.itemSearchThreshold;
      };
      $scope.keypress = function (keyEvent) {
        if (keyEvent.keyCode === 13) {
          keyEvent.preventDefault();
        }
      };
      $scope.initClientSearch = function () {
        const clientSearch = document.getElementById('client-search-input');
        clientSearch.focus();
      };
      $scope.initMatterSearch = function () {
        const matterSearch = document.getElementById('matter-search-input');
        matterSearch.focus();
      };
      async function resetClientsAndMatters() {
        $scope.clients.length = 0;
        $scope.matters.length = 0;
        if ($scope.cm.preventCMReset) return;
        $scope.cm.client = null;
        $scope.cm.matter = null;
      }
      async function fetchClients(initialLoad, keepClient) {
        $scope.clientsLoading = true;
        if (!initialLoad && !keepClient) {
          await resetClientsAndMatters();
        }
        $scope.clientCount = await clientMatterOptionsService.getClientCount($scope.clientQuery);
        if ($scope.$$destroyed) return;
        if ($scope.clientCount < $scope.itemSearchThreshold) {
          await loadClientOptions(keepClient);
        } else {
          $scope.filteredClients.length = 0;
          $scope.clients.length = 0;
          var existingClientId = $scope.cm.client?.id || $scope.cm.matter?.clientId;
          if (existingClientId) {
            var client = await clientMatterOptionsService.getClient(existingClientId);
            if (!$scope.$$destroyed) {
              $scope.cm.client = client;
            }
          }
          $scope.clientsLoading = false;
        }
      }
      async function loadClientOptions(keepClient) {
        await clientMatterOptionsService.listClientOptions($scope.clientQuery).then(response => {
          if ($scope.$$destroyed) return;
          if (response.length > 0) {
            $scope.clients = response;
            $scope.clientsLoading = false;
            if ($scope.cm.client && !keepClient) {
              var found = $scope.clients.find(c => c.id === $scope.cm.client.id);
              if (found) {
                $scope.cm.client = found;
              }
            }
          } else {
            $scope.clientsLoading = false;
          }
        });
      }
      async function fetchMatters(fetchFromMatter, initialLoad, keepMatter, autoSelect) {
        if (!initialLoad && !keepMatter) {
          $scope.matters.length = 0;
        }
        $scope.mattersLoading = true;
        $scope.matterQuery.clientId = $scope.cm.client ? $scope.cm.client.id : null;
        $scope.matterCount = await clientMatterOptionsService.getMatterCount($scope.matterQuery);
        if ($scope.$$destroyed) return;
        if ($scope.matterCount > $scope.itemSearchThreshold && initialLoad && $scope.cm.matter && $scope.cm.matter.id) {
          let matter = await clientMatterOptionsService.getMatter($scope.cm.matter.id);
          if (!$scope.$$destroyed) {
            $scope.cm.matter = matter;
          }
        } else if ($scope.matterCount < $scope.itemSearchThreshold && !$scope.clientOnly) {
          await loadMatterOptions(fetchFromMatter, initialLoad, keepMatter, autoSelect);
        } else {
          $scope.mattersLoading = false;
        }
      }
      async function loadMatterOptions(fetchFromMatter, initialLoad, keepMatter, autoSelect) {
        if ($scope.matters.length > 0 && isMatterQueryEqual($scope.matterQuery)) {
          return $scope.matters;
        } else {
          $scope.mattersLoading = true;
          $scope.matters.length = 0;
          $scope.matterQuery.clientId = $scope.cm.client?.id;
          await clientMatterOptionsService.listMatterOptions($scope.matterQuery).then(matters => {
            if ($scope.$$destroyed) return;
            $scope.lastMatterQuery = {
              ...$scope.matterQuery
            };
            $scope.matters = matters;
            $scope.mattersLoading = false;
            if (!fetchFromMatter) {
              if ($scope.cm.matter && !keepMatter) {
                var found = $scope.matters.find(m => m.id === $scope.cm.matter.id);
                if (found) {
                  $scope.cm.matter = found;
                }
              }
              if ($scope.matters.length === 1 && autoSelect) {
                $scope.cm.matter = $scope.matters[0];
                $scope.matterChange();
              }
            }
            if (initialLoad && $scope.cm.matter) {
              var foundMatter = $scope.matters.find(m => m.id === $scope.cm.matter.id);
              if (foundMatter) {
                $scope.cm.matter = foundMatter;
              }
            }
          });
        }
      }
      $scope.matterChange = async () => {
        if (!$scope.clientOnly) {
          if (!$scope.cm.matter?.id) {
            if ($scope.cm.client) {
              if ($scope.matters.length === 1) {
                $scope.cm.matter = $scope.matters[0];
              } else {
                await fetchMatters();
              }
            }
            return;
          }
        }
        if ($scope.cm.matter?.clientId && $scope.cm.matter.clientId !== $scope.cm.client?.id) {
          var client = await clientMatterOptionsService.getClient($scope.cm.matter.clientId);
          $scope.client = client;
          loadMatterOptions(true);
        }
      };
      $scope.toggleSearch = function () {
        if (!$scope.clientsLoading) {
          $scope.searchingClients = !$scope.searchingClients;
          if (!$scope.searchingClients) {
            $scope.clientQuery.search = '';
            $scope.filteredClients.length = 0;
          }
          if ($scope.searchingMatters && $scope.searchingClients) {
            $scope.searchingMatters = false;
            $scope.matterQuery.search = '';
          }
          if ($scope.cm.client) {
            $scope.clientQuery.search = '';
            $scope.filteredClients.length = 0;
            $scope.clients.length = 0;
            fetchClients(false, true);
          }
        }
      };
      $scope.toggleMatterSearch = function () {
        if (!$scope.mattersLoading) {
          $scope.searchingMatters = !$scope.searchingMatters;
          if (!$scope.searchingMatters) {
            $scope.matterQuery.search = '';
            $scope.filteredMatters.length = 0;
          }
          if ($scope.searchingClients && $scope.searchingMatters) {
            $scope.searchingClients = false;
            $scope.clientQuery.search = '';
          }
          if ($scope.cm.matter) {
            $scope.matterQuery.search = '';
            $scope.filteredMatters.length = 0;
            $scope.matters.length = 0;
            fetchMatters(false, false, true);
          }
        }
      };
      async function clientSearch(newVal, oldVal) {
        if (newVal.length > 0) {
          $scope.showClientTypeToSearch = false;
        }
        if (newVal !== $scope.cm.client?.label && newVal.length > 0 || oldVal.length > 0 && newVal.length === 0) {
          await fetchClients(false, true);
        }
      }
      async function matterSearch(newVal, oldVal) {
        if (newVal !== $scope.cm.matter?.label && newVal.length > 0 || oldVal.length > 0 && newVal.length === 0) {
          await fetchMatters(true);
        }
      }
      $scope.selectClientFromSearch = function (client) {
        if (client?.id !== $scope.client?.id) {
          $scope.searchingClients = false;
          $scope.clientQuery.search = '';
          $scope.cm.client = client;
          $scope.filteredClients.length = 0;
          if ($scope.cm.matter?.clientId !== client?.id) {
            fetchMatters(false, false, false, true);
          }
        }
      };
      $scope.selectMatterFromSearch = async function (matter) {
        $scope.searchingMatters = false;
        $scope.matterQuery.search = '';
        $scope.cm.matter = matter;
        $scope.filteredMatters.length = 0;
        if ($scope.cm.client === null || $scope.cm.client === undefined) {
          let matterClient = $scope.clients.find(x => x.id === matter.clientId);
          if (matterClient) {
            $scope.cm.client = matterClient;
          } else {
            matterClient = await clientMatterOptionsService.getClient(matter.clientId);
            $scope.cm.client = matterClient;
          }
        }
      };
      $scope.clearClient = async function () {
        if ($scope.cm) {
          $scope.cm.client = null;
          if ($scope.cm.matter) {
            $scope.cm.matter.client = null;
            $scope.cm.matter.clientId = null;
            $scope.cm.matter = null;
          }
        }
        if ($scope.clientQuery) {
          $scope.clientQuery.search = '';
        }
        if ($scope.matterQuery) {
          $scope.matterQuery.search = '';
        }
        await fetchClients();
        await fetchMatters();
      };
      $scope.clearMatter = async function () {
        $scope.cm.matter = null;
        $scope.matterQuery.search = '';
        await fetchMatters();
      };
      $scope.$watchGroup(['queryFilter.involved', 'queryFilter.originating', 'queryFilter.primary', 'queryFilter.reviewer', 'queryFilter.scopeAccount', 'queryFilter.showSecondarySplitMatter'], async (newVals, oldVals) => {
        if (newVals === oldVals) return; // skip initial fire

        const [involved, originating, primary, reviewer, scopeAccount, showSplit] = newVals;
        const [oldInvolved, oldOriginating, oldPrimary, oldReviewer, oldScopeAccount, oldShowSplit] = oldVals;
        const scopeChanged = involved !== oldInvolved || originating !== oldOriginating || primary !== oldPrimary || reviewer !== oldReviewer || scopeAccount !== oldScopeAccount;
        const splitChanged = showSplit !== oldShowSplit;
        if (!scopeChanged && !splitChanged) return;
        Object.assign($scope.matterQuery, {
          involved,
          originating,
          primary,
          reviewer,
          scopeAccount,
          showSecondarySplitMatter: showSplit
        });
        Object.assign($scope.clientQuery, {
          involved,
          originating,
          primary,
          reviewer,
          scopeAccount,
          showSecondarySplitMatter: showSplit
        });
        if (scopeChanged) {
          $scope.clientQuery.search = '';
          $scope.filteredClients.length = 0;
          await fetchClients(false, true);
        }
        await fetchMatters();
      });
      $scope.$watch('clientQuery.search', async (newVal, oldVal) => {
        if ($scope.clients.length > 0 && $scope.clients.length <= $scope.clientCount && newVal.length > oldVal.length) {
          $scope.filteredClients = $scope.clients.filter(x => x.label.toLowerCase().indexOf($scope.clientQuery.search.toLowerCase()) > -1);
        } else {
          $scope.filteredClients.length = 0;
          if ($scope.searchingClients) {
            await clientSearch(newVal, oldVal);
          }
        }
      });
      $scope.$watch('matterQuery.search', async (newVal, oldVal) => {
        if ($scope.matters.length > 0 && $scope.matters.length <= $scope.matterCount && newVal.length > oldVal.length) {
          $scope.filteredMatters = $scope.matters.filter(x => x.label.toLowerCase().indexOf($scope.matterQuery.search.toLowerCase()) > -1);
        } else {
          $scope.filteredMatters.length = 0;
          if ($scope.searchingMatters) {
            await matterSearch(newVal, oldVal);
          }
        }
      });
      $scope.$watch('cm.client', async (newVal, oldVal) => {
        if (newVal?.id !== oldVal?.id) {
          $scope.selectClientFromSearch(newVal);
        }
      });
      $scope.addMatter = () => {
        $scope.help = false;
        $state.go('.matter', {
          clientId: $scope.cm.client?.id
        });
      };
      $scope.handleBlur = () => {
        $scope.searchingClients = false;
        $scope.searchingMatters = false;
      };
      $scope.handleKeydown = function (event, list, highlightedIndex, containerId, selectItemFunction) {
        switch (event.key) {
          case 'ArrowDown':
            event.preventDefault();
            $scope[highlightedIndex] = ($scope[highlightedIndex] + 1) % list.length;
            scrollToHighlightedItem(containerId, $scope[highlightedIndex]);
            break;
          case 'ArrowUp':
            event.preventDefault();
            $scope[highlightedIndex] = ($scope[highlightedIndex] - 1 + list.length) % list.length;
            scrollToHighlightedItem(containerId, $scope[highlightedIndex]);
            break;
          case 'Enter':
            event.preventDefault();
            if ($scope[highlightedIndex] >= 0) {
              selectItemFunction(list[$scope[highlightedIndex]]);
            }
            break;
          case 'Tab':
            // If something is highlighted, select it
            if ($scope[highlightedIndex] >= 0) {
              selectItemFunction(list[$scope[highlightedIndex]]);
            }
            // Then close the dropdown in either case
            if (containerId === 'client-dropdown') {
              $scope.searchingClients = false;
            } else if (containerId === 'matter-dropdown') {
              $scope.searchingMatters = false;
            }
            // IMPORTANT: do NOT call event.preventDefault() so
            // focus naturally moves to the next element.
            break;
          case 'Escape':
            // Close dropdown without selecting anything
            if (containerId === 'client-dropdown') {
              $scope.searchingClients = false;
              $scope.highlightedClientIndex = -1;
            } else if (containerId === 'matter-dropdown') {
              $scope.searchingMatters = false;
              $scope.highlightedMatterIndex = -1;
            }
            // Prevent default so it doesn't bubble up
            event.preventDefault();
            break;
        }
      };
      $scope.handleClientKeydown = function (event) {
        const clientsList = $scope.filteredClients.length > 0 ? $scope.filteredClients : $scope.clients;
        $scope.handleKeydown(event, clientsList, 'highlightedClientIndex', 'client-dropdown', $scope.selectClientFromSearch);
      };
      $scope.handleMatterKeydown = function (event) {
        const mattersList = $scope.filteredMatters.length > 0 ? $scope.filteredMatters : $scope.matters;
        $scope.handleKeydown(event, mattersList, 'highlightedMatterIndex', 'matter-dropdown', $scope.selectMatterFromSearch);
      };
      function scrollToHighlightedItem(containerId, index) {
        const container = document.getElementById(containerId);
        const item = container ? container.querySelectorAll('.active-result')[index] : null;
        if (item) {
          item.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'nearest'
          });
        }
      }
      function isMatterQueryEqual(query) {
        return $scope.lastMatterQuery.originating === query.originating && $scope.lastMatterQuery.involved === query.involved && $scope.lastMatterQuery.reviewer === query.reviewer && $scope.lastMatterQuery.primary === query.primary && $scope.lastMatterQuery.scopeAccount === query.scopeAccount && $scope.lastMatterQuery.status === query.status && $scope.lastMatterQuery.clientId === query.clientId && $scope.lastMatterQuery.showSecondarySplitMatter === query.showSecondarySplitMatter;
      }
      if ($scope.cm.client?.id) {
        $scope.matterQuery.clientId = $scope.cm.client?.id;
      }
      fetchClients(true);
      fetchMatters(false, true);
    }]
  };
}]);
angular.module('leanlaw').directive('clickOutside', ['$document', function ($document) {
  return {
    restrict: 'A',
    scope: {
      clickOutside: '&'
    },
    link: function (scope, element) {
      function handleClick(event) {
        if (!element[0].contains(event.target)) {
          scope.$apply(function () {
            scope.clickOutside();
          });
        }
      }
      $document.on('click', handleClick);
      scope.$on('$destroy', function () {
        $document.off('click', handleClick);
      });
    }
  };
}]);